export interface ICreateTag {
  name: { [key: string]: string };
  _method: "PUT" | "POST"
}
